<template>
  <div class="verify-form-container">
    <van-nav-bar
      :title="$t('verify_title')"
      left-arrow
    >
      <template #left>
        <img @click="navBack" class="back" src="../../assets/back.svg" alt="" />
      </template>
    </van-nav-bar>
    <div class="form">
      <div class="form-block">
        <div class="form-block-title" @click="personOpen = !personOpen">
          <div class="title-left">
            <img src="../../assets/person_label.png" alt="" />
            {{ $t("personal_data") }}
          </div>
          <div class="title-right" :class="personOpen ? 'rotate' : ''">
            <img src="../../assets/arrow-right-grey.svg" alt="" />
          </div>
        </div>
        <div class="form-block-content" v-if="personOpen">
          <div class="content-row">
            <div class="content-row-left">
              <input
                v-model="name"
                type="text"
                :placeholder="
                  $t('enter_name')
                "
              />
            </div>
          </div>
          <div class="content-row">
            <div class="content-row-left">
              <input
                v-model="phone"
                type="text"
                :placeholder="
                  $t('enter_phone')
                "
              />
            </div>
          </div>
          <div class="content-row">
            <div class="content-row-left">
              <input
                v-model="age"
                type="text"
                :placeholder="
                  $t('enter_age')
                "
              />
            </div>
          </div>
          <div class="content-row" @click="genderShow = true">
            <div class="content-row-left">
              <div class="selector" v-if="gender == ''">
                {{ $t('select_gender') }}
              </div>
              <div class="selector" v-if="gender != ''">
                {{ locale == "zh" ? gender.zhLabel : gender.enLabel }}
              </div>
            </div>
            <div class="content-row-right">
              <img src="../../assets/arrow-right-grey.svg" alt="" />
            </div>
          </div>
          <div class="content-row">
            <div class="content-row-left">
              <input
                v-model="email"
                type="text"
                :placeholder="
                  $t('enter_email')
                "
              />
            </div>
          </div>
          <div class="content-row">
            <div class="content-row-left">
              <input
                v-model="address"
                type="text"
                :placeholder="
                  $t('enter_current_address')
                "
              />
            </div>
          </div>
          <div class="content-row" @click="marryShow = true">
            <div class="content-row-left">
              <div class="selector" v-if="marry == ''">
                {{ $t("options_marital_status") }}
              </div>
              <div class="selector" v-if="marry != ''">
                {{ locale == "zh" ? marry.zhLabel : marry.enLabel }}
              </div>
            </div>
            <div class="content-row-right">
              <img src="../../assets/arrow-right-grey.svg" alt="" />
            </div>
          </div>
          <div class="content-row" @click="eduShow = true">
            <div class="content-row-left">
              <div class="selector" v-if="edu == ''">
                {{
                  $t("option_education_attainment")
                }}
              </div>
              <div class="selector" v-if="edu != ''">
                {{ locale == "zh" ? edu.zhLabel : edu.enLabel }}
              </div>
            </div>
            <div class="content-row-right">
              <img src="../../assets/arrow-right-grey.svg" alt="" />
            </div>
          </div>
          <div class="content-img">
            <div class="content-img-item">
              <div class="title">
                {{ $t("front_of_documents") }}
              </div>
              <div class="upload-box">
                <van-uploader
                  max-count="1"
                  preview-size="110px"
                  v-model="frontList"
                  :after-read="frontUpload"
                  @delete="frontDelete"
                >
                  <div class="upload-btn">
                    <img src="../../assets/upload_btn.svg" alt="" />
                  </div>
                </van-uploader>
              </div>
            </div>
            <div class="content-img-item">
              <div class="title">
                {{ $t("back_of_documents") }}
              </div>
              <div class="upload-box">
                <van-uploader
                  max-count="1"
                  preview-size="110px"
                  v-model="backList"
                  :after-read="backUpload"
                  @delete="backDelete"
                >
                  <div class="upload-btn">
                    <img src="../../assets/upload_btn.svg" alt="" />
                  </div>
                </van-uploader>
              </div>
            </div>
          </div>
          <div class="submit-btn" @click="editVerifyInfo">
            {{
              $t("confirm_personal_infomation")
            }}
          </div>
        </div>
      </div>
      <div class="form-block">
        <div class="form-block-title" @click="officeOpen = !officeOpen">
          <div class="title-left">
            <img src="../../assets/office_label.png" alt="" />
            {{ $t("work_infomation") }}
          </div>
          <div class="title-right" :class="officeOpen ? 'rotate' : ''">
            <img src="../../assets/arrow-right-grey.svg" alt="" />
          </div>
        </div>
        <div class="form-block-content" v-if="officeOpen">
          <div class="content-row" @click="officeShow = true">
            <div class="content-row-left">
              <div class="selector" v-if="office == ''">
                {{ $t("option_type_of_job") }}
              </div>
              <div class="selector" v-if="office != ''">
                {{ locale == "zh" ? office.zhLabel : office.enLabel }}
              </div>
            </div>
            <div class="content-row-right">
              <img src="../../assets/arrow-right-grey.svg" alt="" />
            </div>
          </div>
          <div class="content-row" @click="yearShow = true">
            <div class="content-row-left">
              <div class="selector" v-if="year == ''">
                {{
                  $t("option_total_working_years")
                }}
              </div>
              <div class="selector" v-if="year != ''">
                {{ locale == "zh" ? year.zhLabel : year.enLabel }}
              </div>
            </div>
            <div class="content-row-right">
              <img src="../../assets/arrow-right-grey.svg" alt="" />
            </div>
          </div>
          <div class="content-row" @click="salaryShow = true">
            <div class="content-row-left">
              <div class="selector" v-if="salary == ''">
                {{ $t("option_monthly_income") }}
              </div>
              <div class="selector" v-if="salary != ''">
                {{ locale == "zh" ? salary.zhLabel : salary.enLabel }}
              </div>
            </div>
            <div class="content-row-right">
              <img src="../../assets/arrow-right-grey.svg" alt="" />
            </div>
          </div>
          <div class="content-row" @click="familyShow = true">
            <div class="content-row-left">
              <div class="selector" v-if="family == ''">
                {{ $t("monthly_household_income") }}
              </div>
              <div class="selector" v-if="family != ''">
                {{ locale == "zh" ? family.zhLabel : family.enLabel }}
              </div>
            </div>
            <div class="content-row-right">
              <img src="../../assets/arrow-right-grey.svg" alt="" />
            </div>
          </div>
          <div class="submit-btn" @click="editVerifyInfo">
            {{ $t("confirm_work_information") }}
          </div>
        </div>
      </div>
      <div class="form-block">
        <div class="form-block-title" @click="receiveOpen = !receiveOpen">
          <div class="title-left">
            <img src="../../assets/receive_label.png" alt="" />
            {{ $t("beneficiary_information") }}
          </div>
          <div class="title-right" :class="receiveOpen ? 'rotate' : ''">
            <img src="../../assets/arrow-right-grey.svg" alt="" />
          </div>
        </div>
        <div class="form-block-content" v-if="receiveOpen">
          <div class="content-row">
            <div class="content-row-left">
              <input
                v-model="beneficiary_address"
                type="text"
                :placeholder="
                  $t('beneficiary_address_trc20')
                "
              />
            </div>
          </div>
          <div class="submit-btn" @click="editVerifyInfo">
            {{
              $t("confirm_beneficiary_information")
            }}
          </div>
        </div>
      </div>
    </div>
    <van-popup position="bottom" v-model="genderShow">
      <van-picker
        @confirm="genderConfirm"
        @cancel="genderShow = false"
        show-toolbar
        :columns="genderOptions"
        :value-key="locale == 'zh' ? 'zhLabel' : 'enLabel'"
        :confirm-button-text="locale == 'zh' ? $t('confirm') : 'Confirm'"
        :cancel-button-text="locale == 'zh' ? $t('cancel') : 'Cancel'"
      />
    </van-popup>
    <van-popup position="bottom" v-model="marryShow">
      <van-picker
        @confirm="marryConfirm"
        @cancel="marryShow = false"
        show-toolbar
        :columns="marryOptions"
        :value-key="locale == 'zh' ? 'zhLabel' : 'enLabel'"
        :confirm-button-text="locale == 'zh' ? $t('confirm') : 'Confirm'"
        :cancel-button-text="locale == 'zh' ? $t('cancel') : 'Cancel'"
      />
    </van-popup>
    <van-popup position="bottom" v-model="eduShow">
      <van-picker
        @confirm="eduConfirm"
        @cancel="eduShow = false"
        show-toolbar
        :columns="eduOptions"
        :value-key="locale == 'zh' ? 'zhLabel' : 'enLabel'"
        :confirm-button-text="locale == 'zh' ? $t('confirm') : 'Confirm'"
        :cancel-button-text="locale == 'zh' ? $t('cancel') : 'Cancel'"
      />
    </van-popup>
    <van-popup position="bottom" v-model="officeShow">
      <van-picker
        @confirm="officeConfirm"
        @cancel="officeShow = false"
        show-toolbar
        :columns="officeOptions"
        :value-key="locale == 'zh' ? 'zhLabel' : 'enLabel'"
        :confirm-button-text="locale == 'zh' ? $t('confirm') : 'Confirm'"
        :cancel-button-text="locale == 'zh' ? $t('cancel') : 'Cancel'"
      />
    </van-popup>
    <van-popup position="bottom" v-model="yearShow">
      <van-picker
        @confirm="yearConfirm"
        @cancel="yearShow = false"
        show-toolbar
        :columns="yearOptions"
        :value-key="locale == 'zh' ? 'zhLabel' : 'enLabel'"
        :confirm-button-text="locale == 'zh' ? $t('confirm') : 'Confirm'"
        :cancel-button-text="locale == 'zh' ? $t('cancel') : 'Cancel'"
      />
    </van-popup>
    <van-popup position="bottom" v-model="salaryShow">
      <van-picker
        @confirm="salaryConfirm"
        @cancel="salaryShow = false"
        show-toolbar
        :columns="salaryOptions"
        :value-key="locale == 'zh' ? 'zhLabel' : 'enLabel'"
        :confirm-button-text="locale == 'zh' ? $t('confirm') : 'Confirm'"
        :cancel-button-text="locale == 'zh' ? $t('cancel') : 'Cancel'"
      />
    </van-popup>
    <van-popup position="bottom" v-model="familyShow">
      <van-picker
        @confirm="familyConfirm"
        @cancel="familyShow = false"
        show-toolbar
        :columns="familyOptions"
        :value-key="locale == 'zh' ? 'zhLabel' : 'enLabel'"
        :confirm-button-text="locale == 'zh' ? $t('confirm') : 'Confirm'"
        :cancel-button-text="locale == 'zh' ? $t('cancel') : 'Cancel'"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      locale: "en",
      frontImg: "",
      backImg: "",
      frontList: [],
      backList: [],
      genderShow: false,
      genderOptions: [
        {
          key: "male",
          zhLabel: "男",
          enLabel: "male",
        },
        {
          key: "female",
          zhLabel: "女",
          enLabel: "female",
        },
      ],
      gender: "",
      marryShow: false,
      marryOptions: [
        {
          key: "divorce",
          zhLabel: "離婚",
          enLabel: "divorce",
        },
        {
          key: "unmarried",
          zhLabel: "未婚",
          enLabel: "unmarried",
        },
        {
          key: "married",
          zhLabel: "已婚",
          enLabel: "married",
        },
      ],
      marry: "",
      eduShow: false,
      eduOptions: [
        {
          key: "doctoral",
          zhLabel: "博士學位",
          enLabel: "doctoral",
        },
        {
          key: "master",
          zhLabel: "碩士學位",
          enLabel: "master",
        },
        {
          key: "bachelor",
          zhLabel: "學士學位",
          enLabel: "bachelor",
        },
        {
          key: "high_school",
          zhLabel: "高中學歷",
          enLabel: "high_school",
        },
      ],
      edu: "",
      officeShow: false,
      officeOptions: [
        {
          key: "self-company",
          zhLabel: "自營公司",
          enLabel: "self-company",
        },
        {
          key: "salaried",
          zhLabel: "受薪",
          enLabel: "salaried",
        },
      ],
      office: "",
      yearShow: false,
      yearOptions: [
        {
          key: "0-1",
          zhLabel: "0-1",
          enLabel: "0-1",
        },
        {
          key: "1-3",
          zhLabel: "1-3",
          enLabel: "1-3",
        },
        {
          key: "3-5",
          zhLabel: "3-5",
          enLabel: "3-5",
        },
        {
          key: ">5",
          zhLabel: ">5",
          enLabel: ">5",
        },
      ],
      year: "",
      salaryShow: false,
      salaryOptions: [
        {
          key: "0-14999",
          zhLabel: "0-14999",
          enLabel: "0-14999",
        },
        {
          key: "15000-24999",
          zhLabel: "15000-24999",
          enLabel: "15000-24999",
        },
        {
          key: "25000-34999",
          zhLabel: "25000-34999",
          enLabel: "25000-34999",
        },
        {
          key: "35000-44999",
          zhLabel: "35000-44999",
          enLabel: "35000-44999",
        },
        {
          key: "45000",
          zhLabel: "45000",
          enLabel: "45000",
        },
      ],
      salary: "",
      familyShow: false,
      familyOptions: [
        {
          key: "0-14999",
          zhLabel: "0-14999",
          enLabel: "0-14999",
        },
        {
          key: "15000-24999",
          zhLabel: "15000-24999",
          enLabel: "15000-24999",
        },
        {
          key: "25000-34999",
          zhLabel: "25000-34999",
          enLabel: "25000-34999",
        },
        {
          key: "35000-44999",
          zhLabel: "35000-44999",
          enLabel: "35000-44999",
        },
        {
          key: "45000",
          zhLabel: "45000",
          enLabel: "45000",
        },
      ],
      family: "",
      personOpen: true,
      officeOpen: true,
      receiveOpen: true,
      name: "",
      phone: "",
      age: "",
      email: "",
      address: "",
      beneficiary_address: "",
    };
  },
  created() {
    window.scrollTo(0, 0);
    if (this.I18n.locale.indexOf("zh") != -1) {
      this.locale = "zh";
    }
    this.getVerifyInfo();
  },
  methods: {
    async getVerifyInfo() {
      const res = await this.$api.getVerifyInfo();
      if (res.code == 200) {
        let info = res.data;
        this.name = info.name;
        this.phone = info.phone;
        this.age = info.age;
        this.gender = info.gender
          ? this.genderOptions.filter((item) => item.key == info.gender)[0]
          : "";
        this.email = info.email;
        this.address = info.address;
        this.marry = info.marital_status
          ? this.marryOptions.filter(
              (item) => item.key == info.marital_status
            )[0]
          : "";
        this.edu = info.education_attainment
          ? this.eduOptions.filter(
              (item) => item.key == info.education_attainment
            )[0]
          : "";
        info.front_of_document
          ? this.frontList.push({ url: info.front_of_document })
          : [];
        info.back_of_document
          ? this.backList.push({ url: info.back_of_document })
          : [];
        this.frontImg = info.front_of_document;
        this.backImg = info.back_of_document;
        this.office = info.type_of_job
          ? this.officeOptions.filter((item) => item.key == info.type_of_job)[0]
          : "";
        this.year = info.total_working_years
          ? this.yearOptions.filter(
              (item) => item.key == info.total_working_years
            )[0]
          : "";
        this.salary = info.monthly_income
          ? this.salaryOptions.filter(
              (item) => item.key == info.monthly_income
            )[0]
          : "";
        this.family = info.monthly_household_income
          ? this.familyOptions.filter(
              (item) => item.key == info.monthly_household_income
            )[0]
          : "";
        this.beneficiary_address = info.beneficiary_address;
      }
    },
    async editVerifyInfo() {
      let data = {
        name: this.name,
        phone: this.phone,
        age: this.age,
        gender: this.gender.key ? this.gender.key : "",
        email: this.email,
        address: this.address,
        marital_status: this.marry.key ? this.marry.key : "",
        education_attainment: this.edu.key ? this.edu.key : "",
        front_of_document: this.frontImg,
        back_of_document: this.backImg,
        type_of_job: this.office.key ? this.office.key : "",
        total_working_years: this.year.key ? this.year.key : "",
        monthly_income: this.salary.key ? this.salary.key : "",
        monthly_household_income: this.family.key ? this.family.key : "",
        beneficiary_address: this.beneficiary_address,
      };
      const res = await this.$api.editVerifyInfo(data);
      if (res.code == 200) {
        if (
          !this.name ||
          !this.phone ||
          !this.age ||
          !this.gender ||
          !this.email ||
          !this.address ||
          !this.marry ||
          !this.edu ||
          !this.frontImg ||
          !this.backImg ||
          !this.office ||
          !this.year ||
          !this.salary ||
          !this.family ||
          !this.beneficiary_address
        ) {
          this.$Toast("submit success");
        } else {
          this.$Toast("submit success");
          this.$router.go(-1);
        }
      } else {
        this.$Toast(res.message);
      }
    },
    navBack() {
      this.$router.go(-1);
    },
    async frontUpload(file) {
      // 此时可以自行将文件上传至服务器
      let formData = new FormData();
      formData.append("image", file.file);
      this.$Toast.loading({ duration: 0 });

      try {
        const res = await this.$api.uploadImage(formData);
        if (res.code == 200) {
          this.$Toast("upload success");
          this.frontImg = res.data.url;
        } else {
          this.$Toast(res.message);
          this.frontImg = "";
          this.$nextTick(() => {
            this.frontList = [];
          });
        }
      } catch (error) {
        this.$Toast("upload failed,please retry");
        this.frontImg = "";
        this.$nextTick(() => {
          this.frontList = [];
        });
      }
    },
    async backUpload(file) {
      // 此时可以自行将文件上传至服务器
      let formData = new FormData();
      formData.append("image", file.file);
      this.$Toast.loading({ duration: 0 });

      try {
        const res = await this.$api.uploadImage(formData);
        if (res.code == 200) {
          this.$Toast("upload success");
          this.backImg = res.data.url;
        } else {
          this.$Toast(res.message);
          this.backImg = "";
          this.$nextTick(() => {
            this.backList = [];
          });
        }
      } catch (error) {
        this.$Toast("upload failed,please retry");
        this.backImg = "";
        this.$nextTick(() => {
          this.backList = [];
        });
      }
    },
    frontDelete() {
      this.frontImg = "";
    },
    backDelete() {
      this.backImg = "";
    },
    genderConfirm(e) {
      this.gender = e;
      this.genderShow = false;
    },
    marryConfirm(e) {
      this.marry = e;
      this.marryShow = false;
    },
    eduConfirm(e) {
      this.edu = e;
      this.eduShow = false;
    },
    officeConfirm(e) {
      this.office = e;
      this.officeShow = false;
    },
    yearConfirm(e) {
      this.year = e;
      this.yearShow = false;
    },
    salaryConfirm(e) {
      this.salary = e;
      this.salaryShow = false;
    },
    familyConfirm(e) {
      this.family = e;
      this.familyShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.verify-form-container {
  padding: 0 15px 15px;
  background: #fff;
  min-height: calc(100vh - 15px);
  .back {
    width: 30px;
    height: 15px;
  }
  .form {
    &-block {
      padding: 10px 0;
      &-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title-left {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: 600;
          img {
            width: 30px;
            height: 30px;
            margin-right: 10px;
          }
        }
        .title-right {
          img {
            width: 20px;
            height: 20px;
          }
        }
        .rotate {
          img {
            transform: rotate(90deg);
          }
        }
      }
      &-content {
        margin-top: 20px;
        .content-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 10px;
          border: 1px solid #aaa;
          border-radius: 5px;
          margin-bottom: 10px;
          &-left {
            flex: 1;
            input {
              width: 100%;
              padding: 15px 0;
              border: none;
            }
            .selector {
              padding: 15px 0;
              color: #333;
            }
          }
          &-right {
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 20px;
              height: 20px;
            }
          }
        }
        .content-img {
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          margin-top: 10px;
          &-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .upload-box {
              margin-top: 15px;
              .upload-btn {
                width: 110px;
                height: 110px;
                border: 1px solid #000;
                border-radius: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }
        }
        .submit-btn {
          margin-top: 20px;
          padding: 15px 0;
          text-align: center;
          text-align: center;
          border-radius: 50px;
          background: rgb(37, 161, 169);
          color: rgb(255, 255, 255);
          font-size: 18px;
          font-weight: 600;
        }
      }
    }
  }
}
</style>